// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminSettings_adminSettingsContainer__z7tlA {
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
    background-color: #000000;
    min-height: 100vh;
  }
  
  .AdminSettings_mainTitle__M6ylb {
    font-size: 2rem;
    color: #fff;
    margin-bottom: 2rem;
  }
  
  .AdminSettings_settingsWrapper__FAVIT {
    display: flex;
    gap: 2rem;
    background-color: #18181B;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .AdminSettings_sidebar__ozn9T {
    width: 250px;
    padding: 1.5rem;
    background-color: #18181B;
    border-radius: 12px 0 0 12px;
  }
  
  .AdminSettings_tabButton__Jjokw {
    width: 100%;
    padding: 1rem;
    text-align: left;
    background: none;
    border: none;
    font-size: 1rem;
    color: #6c757d;
    cursor: pointer;
    border-radius: 8px;
    margin-bottom: 0.5rem;
    transition: all 0.3s ease;
  }
  
  .AdminSettings_tabButton__Jjokw:hover {
    background-color: #E50914;
    color: #fff;
  }
  
  .AdminSettings_activeTab__vWGpe {
    background-color: #E50914 !important;
    color: #ffffff !important;
  }
  
  .AdminSettings_settingsContent__fkPLt {
    flex: 1 1;
    padding: 2rem;
  }
  
  .AdminSettings_categoryTitle__KKstB {
    font-size: 1.5rem;
    color: #fff;
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid #e9ecef;
  }
  
  .AdminSettings_settingsList__ocrk1 {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
  
  .AdminSettings_settingItem__RdPHm {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background-color: #18181B;
    border-radius: 8px;
  }
  
  .AdminSettings_settingInfo__wRMVS {
    flex: 1 1;
  }
  
  .AdminSettings_settingTitle__pNfug {
    font-size: 1.1rem;
    color: #fff;
    margin-bottom: 0.5rem;
  }
  
  .AdminSettings_settingDescription__8qe5v {
    color: #fff;
    font-size: 0.9rem;
  }
  
  .AdminSettings_settingControl__oXDuO {
    min-width: 120px;
  }
  
  /* Toggle Switch Styles */
  .AdminSettings_toggleSwitch__HSzT- {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }
  
  .AdminSettings_toggleSwitch__HSzT- input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .AdminSettings_slider__ctwTT {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 34px;
  }
  
  .AdminSettings_slider__ctwTT:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
  }
  
  input:checked + .AdminSettings_slider__ctwTT {
    background-color: #E50914;
  }
  
  input:checked + .AdminSettings_slider__ctwTT:before {
    transform: translateX(26px);
  }
  
  /* Select Styles */
  .AdminSettings_select__4QsCk {
    width: 100%;
    padding: 0.5rem;
    border-radius: 4px;
    border: 1px solid #ced4da;
    font-size: 1rem;
    color: #495057;
  }
  
  /* Multi-select Styles */
  .AdminSettings_multiSelect__hbq-O {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .AdminSettings_checkboxLabel__VUMCB {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    color: #fff;
  }
  
  .AdminSettings_actionButtons__7Sts9 {
    margin-top: 2rem;
    display: flex;
    justify-content: flex-end;
  }
  
  .AdminSettings_saveButton__OOzIQ {
    padding: 0.75rem 1.5rem;
    background-color: #E50914;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease;
  }
  
  .AdminSettings_saveButton__OOzIQ:hover {
    background-color: #e50914be;
  }
  
  /* Responsive Styles */
  @media (max-width: 768px) {
    .AdminSettings_settingsWrapper__FAVIT {
      flex-direction: column;
    }
  
    .AdminSettings_sidebar__ozn9T {
      width: 80%;
      border-radius: 12px 12px 0 0;
    }
  
    .AdminSettings_settingItem__RdPHm {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }
  
    .AdminSettings_settingControl__oXDuO {
      width: 100%;
    }
  }
  
  @media (max-width: 480px) {
    .AdminSettings_adminSettingsContainer__z7tlA {
      padding: 1rem;
    }
  
    .AdminSettings_mainTitle__M6ylb {
      font-size: 1.5rem;
    }
  
    .AdminSettings_categoryTitle__KKstB {
      font-size: 1.25rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/CSS/AdminSettings.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA;IACE,SAAO;IACP,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,yBAAyB;EACzB;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,kBAAkB;EAClB;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,cAAc;EAChB;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,UAAU;MACV,4BAA4B;IAC9B;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;IACX;;IAEA;MACE,WAAW;IACb;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;EACF","sourcesContent":[".adminSettingsContainer {\n    padding: 2rem;\n    max-width: 1200px;\n    margin: 0 auto;\n    background-color: #000000;\n    min-height: 100vh;\n  }\n  \n  .mainTitle {\n    font-size: 2rem;\n    color: #fff;\n    margin-bottom: 2rem;\n  }\n  \n  .settingsWrapper {\n    display: flex;\n    gap: 2rem;\n    background-color: #18181B;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .sidebar {\n    width: 250px;\n    padding: 1.5rem;\n    background-color: #18181B;\n    border-radius: 12px 0 0 12px;\n  }\n  \n  .tabButton {\n    width: 100%;\n    padding: 1rem;\n    text-align: left;\n    background: none;\n    border: none;\n    font-size: 1rem;\n    color: #6c757d;\n    cursor: pointer;\n    border-radius: 8px;\n    margin-bottom: 0.5rem;\n    transition: all 0.3s ease;\n  }\n  \n  .tabButton:hover {\n    background-color: #E50914;\n    color: #fff;\n  }\n  \n  .activeTab {\n    background-color: #E50914 !important;\n    color: #ffffff !important;\n  }\n  \n  .settingsContent {\n    flex: 1;\n    padding: 2rem;\n  }\n  \n  .categoryTitle {\n    font-size: 1.5rem;\n    color: #fff;\n    margin-bottom: 2rem;\n    padding-bottom: 1rem;\n    border-bottom: 2px solid #e9ecef;\n  }\n  \n  .settingsList {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n  \n  .settingItem {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n    background-color: #18181B;\n    border-radius: 8px;\n  }\n  \n  .settingInfo {\n    flex: 1;\n  }\n  \n  .settingTitle {\n    font-size: 1.1rem;\n    color: #fff;\n    margin-bottom: 0.5rem;\n  }\n  \n  .settingDescription {\n    color: #fff;\n    font-size: 0.9rem;\n  }\n  \n  .settingControl {\n    min-width: 120px;\n  }\n  \n  /* Toggle Switch Styles */\n  .toggleSwitch {\n    position: relative;\n    display: inline-block;\n    width: 60px;\n    height: 34px;\n  }\n  \n  .toggleSwitch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n  \n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    transition: .4s;\n    border-radius: 34px;\n  }\n  \n  .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 26px;\n    width: 26px;\n    left: 4px;\n    bottom: 4px;\n    background-color: white;\n    transition: .4s;\n    border-radius: 50%;\n  }\n  \n  input:checked + .slider {\n    background-color: #E50914;\n  }\n  \n  input:checked + .slider:before {\n    transform: translateX(26px);\n  }\n  \n  /* Select Styles */\n  .select {\n    width: 100%;\n    padding: 0.5rem;\n    border-radius: 4px;\n    border: 1px solid #ced4da;\n    font-size: 1rem;\n    color: #495057;\n  }\n  \n  /* Multi-select Styles */\n  .multiSelect {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .checkboxLabel {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    color: #fff;\n  }\n  \n  .actionButtons {\n    margin-top: 2rem;\n    display: flex;\n    justify-content: flex-end;\n  }\n  \n  .saveButton {\n    padding: 0.75rem 1.5rem;\n    background-color: #E50914;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 1rem;\n    transition: background-color 0.3s ease;\n  }\n  \n  .saveButton:hover {\n    background-color: #e50914be;\n  }\n  \n  /* Responsive Styles */\n  @media (max-width: 768px) {\n    .settingsWrapper {\n      flex-direction: column;\n    }\n  \n    .sidebar {\n      width: 80%;\n      border-radius: 12px 12px 0 0;\n    }\n  \n    .settingItem {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 1rem;\n    }\n  \n    .settingControl {\n      width: 100%;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .adminSettingsContainer {\n      padding: 1rem;\n    }\n  \n    .mainTitle {\n      font-size: 1.5rem;\n    }\n  \n    .categoryTitle {\n      font-size: 1.25rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminSettingsContainer": `AdminSettings_adminSettingsContainer__z7tlA`,
	"mainTitle": `AdminSettings_mainTitle__M6ylb`,
	"settingsWrapper": `AdminSettings_settingsWrapper__FAVIT`,
	"sidebar": `AdminSettings_sidebar__ozn9T`,
	"tabButton": `AdminSettings_tabButton__Jjokw`,
	"activeTab": `AdminSettings_activeTab__vWGpe`,
	"settingsContent": `AdminSettings_settingsContent__fkPLt`,
	"categoryTitle": `AdminSettings_categoryTitle__KKstB`,
	"settingsList": `AdminSettings_settingsList__ocrk1`,
	"settingItem": `AdminSettings_settingItem__RdPHm`,
	"settingInfo": `AdminSettings_settingInfo__wRMVS`,
	"settingTitle": `AdminSettings_settingTitle__pNfug`,
	"settingDescription": `AdminSettings_settingDescription__8qe5v`,
	"settingControl": `AdminSettings_settingControl__oXDuO`,
	"toggleSwitch": `AdminSettings_toggleSwitch__HSzT-`,
	"slider": `AdminSettings_slider__ctwTT`,
	"select": `AdminSettings_select__4QsCk`,
	"multiSelect": `AdminSettings_multiSelect__hbq-O`,
	"checkboxLabel": `AdminSettings_checkboxLabel__VUMCB`,
	"actionButtons": `AdminSettings_actionButtons__7Sts9`,
	"saveButton": `AdminSettings_saveButton__OOzIQ`
};
export default ___CSS_LOADER_EXPORT___;
